// @core/api/endpoints/calendar/create_event_from_template.ts
// Auto-generated by corebuilder. DO NOT EDIT.

import { getApiClient, type RequestOptions } from '../../client';
import type {
  CreateEventFromTemplateRequest,
  EventResponse,
} from '../../../types/calendar';

const BASE_PATH = '/calendar';

/**
 * Create event from template
 * Creates a new event populated with all fields from the template. Requires specifying the target calendar and start time.
 */
export async function CreateEventFromTemplate(
  template_id: string,
  data: CreateEventFromTemplateRequest,
  options?: RequestOptions
): Promise<EventResponse> {
  const client = getApiClient();
  let requestPath = `${BASE_PATH}/event-templates/:template_id/create-event`;
  requestPath = requestPath.replace(':template_id', encodeURIComponent(template_id));
  const requestOptions = options;
  return client.post<EventResponse>(requestPath, data, requestOptions);
}
